module.exports = __webpack_public_path__ + "vue-app/img/cross-sell-hebergement.c5030115.jpg";